import React, { useState, useEffect } from 'react';
import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';

const isTokenValid = (token) => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const now = Date.now() / 1000;
    return payload.exp && payload.exp > now;
  } catch (e) {
    return false;
  }
};

const getIdBpoFromToken = (token) => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.id_bpo !== undefined ? payload.id_bpo : null;
  } catch (e) {
    return null;
  }
};

const ClienteRoute = () => {
  const [loading, setLoading] = useState(true);
  const [autorizado, setAutorizado] = useState(false);
  const location = useLocation();
  const params = useParams();
  const token = localStorage.getItem('access');

  // EXTRAIR cliente_id DA URL (ex: /dashboard-cliente/2 → cliente_id = 2)
  const cliente_id_rota = params.cliente_id ? parseInt(params.cliente_id) : null;

  useEffect(() => {
    verificarAcesso();
  }, [location.pathname]);

  const verificarAcesso = async () => {
    if (!token || !isTokenValid(token)) {
      setAutorizado(false);
      setLoading(false);
      return;
    }

    try {
      let id_bpo = getIdBpoFromToken(token);

      // Fallback: buscar da API
      if (id_bpo === null) {
        const response = await fetch(`${process.env.REACT_APP_API_BASE}/api/verificar-grupo/`, {
          method: 'GET',
          headers: { 'Authorization': `Bearer ${token}` }
        });

        if (response.ok) {
          const data = await response.json();
          if (data.success) {
            id_bpo = data.id_bpo;
          }
        } else {
          localStorage.clear();
          setAutorizado(false);
          setLoading(false);
          return;
        }
      }

      localStorage.setItem('id_bpo', id_bpo);
      localStorage.setItem('isCliente', id_bpo > 0 ? 'true' : 'false');

      // LÓGICA DE ACESSO:
      // 1. id_bpo === 0 → Operador interno (acesso total)
      // 2. id_bpo === cliente_id_rota → Cliente acessando sua própria área
      // 3. id_bpo !== cliente_id_rota → Cliente tentando acessar área de outro
      
      if (id_bpo === 0 || id_bpo === null) {
        // Operador interno tem acesso total
        console.log('Operador interno - Acesso permitido');
        setAutorizado(true);
      } else if (cliente_id_rota && id_bpo === cliente_id_rota) {
        // Cliente acessando sua própria área
        console.log(`Cliente id_bpo=${id_bpo} acessando sua área`);
        setAutorizado(true);
      } else {
        // Cliente tentando acessar área de outro cliente
        console.log(`Cliente id_bpo=${id_bpo} tentando acessar área do cliente ${cliente_id_rota}`);
        setAutorizado(false);
      }

    } catch (error) {
      console.error('Erro ao verificar acesso:', error);
      setAutorizado(false);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="text-center">
          <div className="spinner-border text-primary mb-3" role="status" style={{ width: '3rem', height: '3rem' }}>
            <span className="visually-hidden">Carregando...</span>
          </div>
          <p className="text-muted">Verificando acesso...</p>
        </div>
      </div>
    );
  }

  if (!token || !isTokenValid(token)) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!autorizado) {
    console.log('Acesso negado para:', location.pathname);
    return <Navigate to="/acesso-negado" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default ClienteRoute;